// Constants
import { BASE_URL } from '../config'

const END_POINTS = {
  FETCH_EMBED_USER: '/v1/embedUser'
}

export const getEmbedUser = (partnerId, tenantName, jwt) => {
  const url = BASE_URL + END_POINTS.FETCH_EMBED_USER
  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      auth: jwt
    },
    body: JSON.stringify({
      partnerId,
      tenantName
    })
  })
    .then((response) => response.json())
    .catch((error) => {
      return {
        error: `Failed to fetch Embed user details: ${error}`
      }
    })
}
